module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-03-8293ba1eacb373f4f58650e54fb3bdc8.jpg";